module.exports = __webpack_public_path__ + "img/kg.cd6ff154.svg";